import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaBitcoin, FaEthereum, FaCoins, FaChartLine, FaCalendarAlt, FaRegClock, FaRegCalendarCheck, FaLock, FaRegHourglass, FaCheckCircle } from 'react-icons/fa';
import { SiTether, SiLitecoin, SiDogecoin } from 'react-icons/si';
import { IoWallet, IoRefreshCircle } from 'react-icons/io5';
import BottomNavigation from './BottomNavigation';
import axios from 'axios';
import { useAuth } from '../security/security/AuthContext';
import { color } from 'framer-motion';

const Order = () => {
  const [activeTab, setActiveTab] = useState('normal');
  const [investments, setInvestments] = useState([]);
  const { userDetails, token, updateUserDetails } = useAuth();
  const [toastNotification, setToastNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [totalEarned, setTotalEarned] = useState(0);
  const [statsExpanded, setStatsExpanded] = useState(false);

  // Styles
  const styles = {
    container: {
      backgroundColor: '#0F172A',
      color: '#E2E8F0',
      minHeight: '100vh',
      paddingBottom: '80px',
      fontFamily: 'Inter, system-ui, sans-serif',
    },
    header: {
      background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
      padding: '16px',
      borderBottom: '1px solid #1E3A5F',
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    statsCard: {
      background: 'linear-gradient(135deg, #1E3A5F 0%, #1E293B 100%)',
      borderRadius: '12px',
      padding: '16px',
      margin: '16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
      marginTop: statsExpanded ? '16px' : '0',
      maxHeight: statsExpanded ? '300px' : '0',
      opacity: statsExpanded ? 1 : 0,
      transition: 'all 0.3s ease',
    },
    statBox: {
      backgroundColor: 'rgba(15, 23, 42, 0.5)',
      padding: '12px',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
    },
    statLabel: {
      fontSize: '12px',
      color: '#94A3B8',
      marginBottom: '4px',
    },
    statValue: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#E2E8F0',
    },
    tabsContainer: {
      display: 'flex',
      padding: '0 16px',
      marginTop: '16px',
      marginBottom: '16px',
      position: 'relative',
    },
    tabButton: {
      flex: 1,
      backgroundColor: 'transparent',
      border: 'none',
      padding: '12px 0',
      fontSize: '14px',
      color: '#94A3B8',
      cursor: 'pointer',
      position: 'relative',
      transition: 'color 0.2s ease',
    },
    activeTab: {
      color: '#38BDF8',
      fontWeight: '600',
    },
    tabIndicator: {
      position: 'absolute',
      bottom: 0,
      height: '3px',
      width: '50%',
      backgroundColor: '#38BDF8',
      borderRadius: '3px 3px 0 0',
      transition: 'transform 0.3s ease',
      transform: activeTab === 'normal' ? 'translateX(0)' : 'translateX(100%)',
    },
    divider: {
      height: '1px',
      backgroundColor: '#1E3A5F',
      margin: '0',
    },
    miningList: {
      padding: '0 16px',
    },
    emptyState: {
      padding: '32px 16px',
      textAlign: 'center',
      color: '#94A3B8',
    },
    miningCard: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      overflow: 'hidden',
      marginBottom: '16px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
      border: '1px solid #334155',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    },
    cardHeader: {
      padding: '16px',
      borderBottom: '1px solid #334155',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    cardTitle: {
      margin: 0,
      fontSize: '16px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    cryptoIcon: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(56, 189, 248, 0.1)',
      color: '#38BDF8',
    },
    statusBadge: {
      fontSize: '12px',
      padding: '4px 8px',
      borderRadius: '12px',
      fontWeight: '500',
    },
    activeBadge: {
      backgroundColor: 'rgba(16, 185, 129, 0.2)',
      color: '#10B981',
    },
    expiredBadge: {
      backgroundColor: 'rgba(239, 68, 68, 0.2)',
      color: '#EF4444',
    },
    cardBody: {
      padding: '16px',
    },
    infoGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
    },
    infoItem: {
      display: 'flex',
      flexDirection: 'column',
    },
    infoLabel: {
      fontSize: '12px',
      color: '#94A3B8',
      marginBottom: '4px',
    },
    infoValue: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#E2E8F0',
    },
    highlight: {
      color: '#38BDF8',
      fontWeight: '600',
    },
    cardFooter: {
      padding: '16px',
      borderTop: '1px solid #334155',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    earnedAmount: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#10B981',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    receiveButton: {
      backgroundColor: '#0284C7',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '8px 16px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'background-color 0.2s ease',
    },
    disabledButton: {
      backgroundColor: '#475569',
      cursor: 'not-allowed',
    },
    lockIcon: {
      fontSize: '12px',
    },
    progressBarOuter: {
      height: '6px',
      backgroundColor: '#334155',
      borderRadius: '3px',
      margin: '12px 0',
      overflow: 'hidden',
    },
    progressBarInner: {
      height: '100%',
      backgroundColor: '#38BDF8',
      borderRadius: '3px',
      transition: 'width 0.3s ease',
    },
    toast: {
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#1E293B',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1001,
      width: '90%',
      maxWidth: '400px',
      border: '1px solid',
    },
    successToast: {
      borderColor: '#10B981',
    },
    errorToast: {
      borderColor: '#EF4444',
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 0',
      color: '#94A3B8',
    },
    spinner: {
      border: '4px solid #1E293B',
      borderTop: '4px solid #38BDF8',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      animation: 'spin 1s linear infinite',
      marginBottom: '16px',
    },
    paragraph: {
      color: 'white',
    },
    timeSpan: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontSize: '13px',
      color: '#94A3B8',
      marginTop: '4px',
    },
    toggleButton: {
      backgroundColor: 'transparent',
      border: 'none',
      color: '#38BDF8',
      fontSize: '14px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      margin: '8px 0 0 auto',
    }
  };

  const refreshUserData = async () => {
    try {
      const userResponse = await axios.get(`https://api.novasoftwaves.com/api/v1/auth/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      updateUserDetails(userResponse.data);
    } catch (error) {
      console.error('Error refreshing user data:', error);
      setToastNotification({ message: 'Failed to refresh user data', type: 'error' });
    }
  };

  const refreshAllData = async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        refreshUserData(),
        fetchInvestments()
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshAllData();
    // Set up auto-refresh every 5 minutes
    const refreshInterval = setInterval(() => {
      refreshAllData();
    }, 5 * 60 * 1000);

    return () => clearInterval(refreshInterval);
  }, []);

  const fetchInvestments = async () => {
    try {
      const response = await axios.get(`https://api.novasoftwaves.com/api/investments/user/${userDetails.email}`);
      // Sort investments by ID in descending order (higher IDs first)
      const sortedInvestments = response.data.sort((a, b) => b.id - a.id);
      setInvestments(sortedInvestments);

      // Calculate total earned amount
      const total = sortedInvestments.reduce((sum, inv) => sum + inv.earnedAmount, 0);
      setTotalEarned(total);
    } catch (error) {
      console.error('Error fetching investments:', error);
      setToastNotification({ 
        message: 'An error occurred while fetching mining data. Please try again.', 
        type: 'error' 
      });
    }
  };

  const handleReceive = async (investmentId, productType) => {
    try {
      const investment = investments.find(inv => inv.id === investmentId);
      const isHighValueProduct = investment.investedAmount >= 5000;
      
      if (isHighValueProduct && new Date(investment.validUntil) > new Date()) {
        setToastNotification({ 
          message: 'This mining reward can only be collected at the end of its cycle.', 
          type: 'error' 
        });
        return;
      }

      await axios.post(`https://api.novasoftwaves.com/api/investments/${investmentId}/receive`);
      await refreshAllData();
      setToastNotification({ 
        message: 'Mining rewards collected successfully!', 
        type: 'success' 
      });
    } catch (error) {
      console.error('Error receiving income:', error);
      let errorMessage = 'An error occurred while collecting rewards. Please try again.';
      
      if (error.response && error.response.data) {
        errorMessage = error.response.data;
      }
      
      setToastNotification({ 
        message: errorMessage, 
        type: 'error' 
      });
    }
  };

  // Assign a crypto icon based on product name
  const getCryptoIcon = (productName) => {
    const name = productName.toLowerCase();
    
    if (name.includes('bitcoin') || name.includes('btc')) {
      return <FaBitcoin />;
    } else if (name.includes('ethereum') || name.includes('eth')) {
      return <FaEthereum />;
    } else if (name.includes('lite') || name.includes('ltc')) {
      return <SiLitecoin />;
    } else if (name.includes('tether') || name.includes('usdt')) {
      return <SiTether />;
    } else if (name.includes('doge')) {
      return <SiDogecoin />;
    } else {
      return <FaCoins />;
    }
  };

  // Format date to relative time (e.g., "3 days left" or "Ended 2 days ago")
  const getTimeRemaining = (endDate) => {
    const end = new Date(endDate);
    const now = new Date();
    const diffTime = end - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 0) {
      return { text: `${diffDays} day${diffDays !== 1 ? 's' : ''} left`, icon: <FaRegHourglass /> };
    } else if (diffDays === 0) {
      return { text: 'Ends today', icon: <FaRegCalendarCheck /> };
    } else {
      return { text: `Ended ${Math.abs(diffDays)} day${Math.abs(diffDays) !== 1 ? 's' : ''} ago`, icon: <FaRegClock /> };
    }
  };

  // Calculate progress percentage of mining contract
  const calculateProgress = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const now = new Date();
    
    const totalDuration = end - start;
    const elapsed = now - start;
    
    if (elapsed <= 0) return 0;
    if (elapsed >= totalDuration) return 100;
    
    return Math.min(100, Math.floor((elapsed / totalDuration) * 100));
  };

  const renderMiningItem = (investment) => {
    const isHighValueProduct = investment.investedAmount >= 5000;
    const isReadyToReceive = !isHighValueProduct || 
      (isHighValueProduct && new Date(investment.validUntil) <= new Date());
    
    const timeInfo = getTimeRemaining(investment.validUntil);
    const progress = calculateProgress(investment.createdAt, investment.validUntil);

    return (
      <div key={investment.id} style={styles.miningCard}>
        <div style={styles.cardHeader}>
          <h3 style={styles.cardTitle}>
            <span style={styles.cryptoIcon}>
              {getCryptoIcon(investment.productName)}
            </span>
            {investment.productName}
          </h3>
          <span style={{
            ...styles.statusBadge,
            ...(investment.active ? styles.activeBadge : styles.expiredBadge)
          }}>
            {investment.active ? 'Active' : 'Stopped'}
          </span>
        </div>
        
        {investment.active && (
          <div style={styles.progressBarOuter}>
            <div style={{
              ...styles.progressBarInner,
              width: `${progress}%`
            }}></div>
          </div>
        )}
        
        <div style={styles.cardBody}>
          <div style={styles.infoGrid}>
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>Mining Rate</span>
              <span style={styles.infoValue}>
                KES {(investment.dailyIncome / 24).toFixed(2)}/hr
              </span>
            </div>
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>Total Return</span>
              <span style={styles.infoValue}>KES {investment.totalIncome}</span>
            </div>
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>Investment</span>
              <span style={styles.infoValue}>KES {investment.investedAmount}</span>
            </div>
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>Mining Period</span>
              <span style={styles.infoValue}>
                {new Date(investment.validUntil).toLocaleDateString()}
              </span>
              <div style={styles.timeSpan}>
                {timeInfo.icon} {timeInfo.text}
              </div>
            </div>
          </div>
        </div>
        
        <div style={styles.cardFooter}>
          <div style={styles.earnedAmount}>
            <FaCoins />
            +KES {investment.earnedAmount.toFixed(2)}
          </div>
          
          {investment.active && (
            <button 
              style={{
                ...styles.receiveButton,
                ...((!isReadyToReceive || investment.earnedAmount <= 0) ? styles.disabledButton : {})
              }} 
              onClick={() => handleReceive(investment.id, investment.productType)} 
              disabled={!isReadyToReceive || investment.earnedAmount <= 0}
            >
              {!isReadyToReceive
                ? (
                  <>
                    <FaLock style={styles.lockIcon} />
                    <span>Locked</span>
                  </>
                ) 
                : (investment.earnedAmount <= 0
                  ? 'No Rewards'
                  : 'Collect'
                )
              }
            </button>
          )}
        </div>
      </div>
    );
  };

  const renderInvestments = () => {
    if (isLoading) {
      return (
        <div style={styles.loadingContainer}>
          <div style={styles.spinner}></div>
          <p>Loading mining operations...</p>
        </div>
      );
    }

    const filteredInvestments = investments
      .filter(inv => activeTab === 'normal' ? inv.active : !inv.active);

    if (filteredInvestments.length === 0) {
      return (
        <div style={styles.emptyState}>
          <p style={styles.paragraph} >
            {activeTab === 'normal' 
              ? "You have no active mining operations." 
              : "You have no stopped mining operations."}
          </p>
          {activeTab === 'normal' && (
            <button 
              style={{
                ...styles.receiveButton, 
                margin: '16px auto 0',
                padding: '12px 24px'
              }}
              onClick={() => window.location.href = '/mining-packages'}
            >
              Start Mining
            </button>
          )}
        </div>
      );
    }

    return filteredInvestments.map(inv => renderMiningItem(inv));
  };

  // Calculate stats for the summary card
  const getTotalInvested = () => {
    return investments.reduce((sum, inv) => sum + inv.investedAmount, 0);
  };

  const getActiveMiningCount = () => {
    return investments.filter(inv => inv.active).length;
  };

  const getDailyEarnings = () => {
    return investments
      .filter(inv => inv.active)
      .reduce((sum, inv) => sum + inv.dailyIncome, 0);
  };

  const getHourlyEarnings = () => {
    return investments
      .filter(inv => inv.active)
      .reduce((sum, inv) => sum + (inv.dailyIncome / 24), 0);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaChartLine /> Mining Dashboard
        </h1>
      </div>
      
      <div style={styles.statsCard}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '14px', color: '#94A3B8' }}>Available Mining Rewards</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#10B981', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <IoWallet />
              KES {totalEarned.toFixed(2)}
            </div>
          </div>
          <button 
            style={{...styles.receiveButton, opacity: totalEarned > 0 ? 1 : 0.5}}
            disabled={totalEarned <= 0}
          >
            <IoRefreshCircle /> Collect All
          </button>
        </div>
        
        <button 
          style={styles.toggleButton} 
          onClick={() => setStatsExpanded(!statsExpanded)}
        >
          {statsExpanded ? 'Hide Details' : 'Show Details'} {statsExpanded ? '▲' : '▼'}
        </button>
        
        <div style={styles.statsGrid}>
          <div style={styles.statBox}>
            <span style={styles.statLabel}>Total Invested</span>
            <span style={styles.statValue}>KES {getTotalInvested().toLocaleString()}</span>
          </div>
          <div style={styles.statBox}>
            <span style={styles.statLabel}>Active Mining</span>
            <span style={styles.statValue}>{getActiveMiningCount()} currencies</span>
          </div>
          <div style={styles.statBox}>
            <span style={styles.statLabel}>Daily Earnings</span>
            <span style={{...styles.statValue, color: '#10B981'}}>KES {getDailyEarnings().toFixed(2)}</span>
          </div>
          <div style={styles.statBox}>
            <span style={styles.statLabel}>Hourly Rate</span>
            <span style={{...styles.statValue, color: '#10B981'}}>KES {getHourlyEarnings().toFixed(2)}</span>
          </div>
        </div>
      </div>
      
      <div style={styles.tabsContainer}>
        <button 
          style={{
            ...styles.tabButton,
            ...(activeTab === 'normal' ? styles.activeTab : {})
          }}
          onClick={() => setActiveTab('normal')}
        >
          Active Mining
        </button>
        <button 
          style={{
            ...styles.tabButton,
            ...(activeTab === 'expired' ? styles.activeTab : {})
          }}
          onClick={() => setActiveTab('expired')}
        >
          Completed
        </button>
        <div style={styles.tabIndicator}></div>
      </div>
      
      <hr style={styles.divider} />
      
      <div style={styles.miningList}>
        {renderInvestments()}
      </div>
      
      <BottomNavigation />
      
      {toastNotification && (
        <div style={{
          ...styles.toast,
          ...(toastNotification.type === 'success' ? styles.successToast : styles.errorToast)
        }}>
          {toastNotification.type === 'success' ? (
            <FaCheckCircle color="#10B981" />
          ) : (
            <FaArrowLeft color="#EF4444" />
          )}
          <div>{toastNotification.message}</div>
        </div>
      )}
      
      {/* CSS Animations */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Order;